// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"66f1855f","619":"e4c2624a"}[chunkId] + ".chunk.css";
};